// removed by extract-text-webpack-plugin
module.exports = {"row":"src-components-shared----Detail-module---row---Z_u_c","description":"src-components-shared----Detail-module---description---1UXsp","content":"src-components-shared----Detail-module---content---2Y6NX"};


//////////////////
// WEBPACK FOOTER
// ./src/components/shared/Detail.module.css
// module id = 649
// module chunks = 168707334958949